import { render, staticRenderFns } from "./AmountPets.vue?vue&type=template&id=cb07197e"
import script from "./AmountPets.vue?vue&type=script&lang=js"
export * from "./AmountPets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports